import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { IGameAssignmentContext, GameAssignmentContext } from '../../../../gameAssignmentState/gameAssignmentContext';
import Button from 'components/Button/Button';
import { DownOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import style from './BottomControlPanel.module.scss';

const BottomControlPanel: React.FC = () => {
	const { changeActiveItemToDisplay, activeItemToDisplay, IDsSelectedCustomers, IDsSelectedRestaurants } =
		useContext<IGameAssignmentContext>(GameAssignmentContext);
	const goOnBtnClasses = classNames({
		[style.hide]: activeItemToDisplay === 'games',
	});

	const handleGoBack = () => {
		if (activeItemToDisplay === 'restaurants') {
			changeActiveItemToDisplay('customers');
		} else if (activeItemToDisplay === 'games') {
			changeActiveItemToDisplay('restaurants');
		}
	};

	const handleGoOn = () => {
		if (activeItemToDisplay === 'customers') {
			changeActiveItemToDisplay('restaurants');
		} else if (activeItemToDisplay === 'restaurants') {
			changeActiveItemToDisplay('games');
		}
	};

	return (
		<div className={style.container} data-test="BottomControlPanel">
			<Button
				theme="outlined"
				onClick={handleGoBack}
				disabled={activeItemToDisplay === 'customers'}
				icon={<DownOutlined className={style.iconLeft} rotate={90} />}>
				<Text translationNameSpace="listing" translationKey="goBackLabel" asFragment={true} />
			</Button>

			<Button
				className={goOnBtnClasses}
				theme="primaryBlue"
				onClick={handleGoOn}
				disabled={
					(activeItemToDisplay === 'customers' && !Object.keys(IDsSelectedCustomers).length) ||
					(activeItemToDisplay === 'restaurants' && !Object.keys(IDsSelectedRestaurants).length) ||
					activeItemToDisplay === 'games'
				}
				iconPosition="post"
				icon={<DownOutlined className={style.iconRight} rotate={270} />}>
				<Text translationNameSpace="listing" translationKey="goOnLabel" asFragment={true} />
			</Button>
		</div>
	);
};

export default BottomControlPanel;
